import { render, staticRenderFns } from "./ItemPartidoAsignacion.vue?vue&type=template&id=56f293b9&scoped=true&"
import script from "./ItemPartidoAsignacion.vue?vue&type=script&lang=js&"
export * from "./ItemPartidoAsignacion.vue?vue&type=script&lang=js&"
import style0 from "./ItemPartidoAsignacion.vue?vue&type=style&index=0&id=56f293b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f293b9",
  null
  
)

export default component.exports